import DateTimePicker from "react-datetime-picker"
import "react-datetime-picker/dist/DateTimePicker.css"
import "react-calendar/dist/Calendar.css"
import "react-clock/dist/Clock.css"
import { format } from "date-fns"
import { ComponentProps, useState } from "react"

type Props = {
  value?: string
  onValueChange: (value: string) => void
} & ComponentProps<typeof DateTimePicker>

export function TimeField(props: Props) {
  const [value, setValue] = useState<Date | null>(null)

  return (
    <DateTimePicker
      format="h:mma"
      disableCalendar
      locale="en-AU"
      onChange={(date) => {
        if (date) {
          if (isNaN(date.getTime())) {
            console.log("Not valid")
            return
          }
          setValue(date)
          props.onValueChange(`${format(date as Date, "h:mma")}`)
        } else {
          setValue(null)
          props.onValueChange("")
        }
      }}
      value={value}
      clearIcon={null}
    />
  )
}
